import {
  Box,
  EllipsisVerticalIcon,
  MuiIconButton,
  MuiMenu
} from "@dealer-center/core-components";
import { UserMenu, openClickedItem } from "./user-menu";
import { Search } from "./search";
import { useState } from "react";
import { useNavBarStore } from "../store";
import type { NavigationMenuItemInterface } from "@dealer-center/ddc-api-commoncontainer-interface";
import { isNavigationMenuItemInterfaceNavigate } from "@dealer-center/ddc-api-commoncontainer-interface";

export const Right = () => {
  const { visibility } = useNavBarStore();

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    useState<null | HTMLElement>(null);

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const mobileMenuId = "primary-search-account-menu-mobile";

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleItemClicked = (itemClicked: NavigationMenuItemInterface) => {
    if (isNavigationMenuItemInterfaceNavigate(itemClicked))
      openClickedItem(itemClicked);
    handleMobileMenuClose();
  };
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const renderMobileMenu = (
    <MuiMenu
      keepMounted
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      id={mobileMenuId}
      open={isMobileMenuOpen}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      onClose={handleMobileMenuClose}
    >
      <UserMenu displayMenuInline onItemClicked={handleItemClicked} />
    </MuiMenu>
  );
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center"
        }}
      >
        <Search iconOnly={visibility.shouldSearchBeAnIcon} />
        {visibility.shouldShowMobileMenu ? (
          <MuiIconButton
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            aria-label="show more options"
            color="inherit"
            size="large"
            onClick={handleMobileMenuOpen}
          >
            <EllipsisVerticalIcon title="More" />
          </MuiIconButton>
        ) : (
          <UserMenu />
        )}
      </Box>
      {renderMobileMenu}
    </>
  );
};
